import { render } from "./EventCard.vue?vue&type=template&id=43aa7e9c&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=43aa7e9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43aa7e9c"

export default script